import { render, staticRenderFns } from "./contact-for-schools.vue?vue&type=template&id=b136eb1e&"
import script from "./contact-for-schools.vue?vue&type=script&lang=js&"
export * from "./contact-for-schools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports